import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { SharedService } from "@shared/services/shared.service";
import { IAdministrativeComplaintView, ICorrespondenceView } from "app/models/mainMenu/mainMenu";
import { BusinessService } from "app/services/business/business.service";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { PreviewCorrespondenceComponent } from "./previewCorrespondence/previewCorrespondence.component";
import { NewCorrespondenceComponent } from "./newCorrespondence/newCorrespondence.component";
import { AddFileCorrespondenceComponent } from "./addFileCorrespondence/addFileCorrespondence.component";
import { EditCorrespondenceComponent } from "./editCorrespondence/editCorrespondence.component";
import { Subscription } from "rxjs";


@Component({
  selector: 'shared-sharedCorrespondence',
  templateUrl: './sharedCorrespondence.component.html',
  styleUrls: ['./sharedCorrespondence.component.scss']
})

export class SharedCorrespondenceComponent implements OnInit {

  @Input() parentPanel: number = 0;

  sharedSubscription: Subscription;
  businessId: number = 0;
  correspondenceList: ICorrespondenceView[] = [];
  complaintId: number = 0;
  complaint: IAdministrativeComplaintView = null;
  businessOnly: boolean = false;
  searchId: number = 0;

  fileName: string = '';

  correspondenceHistoryDirty: boolean = false;

  displayedColumns: string[] = ['preview', 'title', 'type', 'generatedDate', 'sentDate', 'discardedCorrespondence',
    'invalidAddress', 'complaintId', 'edit', 'hasAttachment'];
  dataSource = new MatTableDataSource<ICorrespondenceView>(this.correspondenceList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(
    private complaintService: ComplaintService,
    private businessService: BusinessService,
    private sharedService: SharedService,
    private modalService: MatDialog
  ) {

  }

  ngOnInit(): void {
    if (this.parentPanel == 0) {
      this.sharedSubscription = this.complaintService.updateEvent.subscribe((data: number) => {
        if (data == 3) {
          this.complaintId = this.complaintService.currentComplaint.complaintId;
          this.businessId = this.complaintService.currentComplaint.businessId;
          this.businessOnly = false;
          this.searchId = this.complaintId
          this.getCorrespondence(this.searchId, this.businessOnly);
        }
      });
    } else {
      this.sharedSubscription = this.businessService.updateBusinessEvent.subscribe((data: number) => {
        if (data == 2) {
          this.businessId = this.businessService.businessId;
          this.complaintId = 0;
          this.businessOnly = true;
          this.searchId = this.businessId;
          this.getCorrespondence(this.searchId, this.businessOnly);
        }
      });
    }
  }

  ngOnDestroy() {
    this.sharedSubscription.unsubscribe();
  }

  init() {
  }

  getCorrespondence(id: number, businessOnly: boolean) {
    this.complaintService.getCorrespondence(id, businessOnly).subscribe({
      next: response => {
        this.correspondenceList = response;
        this.dataSource.data = this.correspondenceList;
      },
      error: e => {
        this.sharedService.toastr.error("Could not retrive Correspondence data.");
      },
    });
  }

  newCorrespondence() {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = true;
    config.minWidth = 800;
    // config.maxHeight = 800;
    config.data = {
      complaintId: this.complaintId,
      businessId: this.businessId,
      businessOnly: this.businessOnly
    };
    const dialogRef = this.modalService.open(NewCorrespondenceComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.getCorrespondence(this.searchId, this.businessOnly);
          this.sharedService.openNotice("Remember to print and mail letter OR send via email. Enter the date the letter is sent and retain a copy for your files.");
        }
      },
      error => this.sharedService.toastr.error("Could not preview Correspondence"),
      () => { }
    );
  }

  editCorrespondence(corr: ICorrespondenceView) {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 300;
    config.maxHeight = 800;
    config.data = {
      correspondence: corr,
    };
    const dialogRef = this.modalService.open(EditCorrespondenceComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.getCorrespondence(this.searchId, this.businessOnly)
        }
      },
      error => this.sharedService.toastr.error("Error"),
      () => { }
    );
  }

  previewCorrespondence(corr: ICorrespondenceView) {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 600;
    config.minHeight = 400;    
    config.maxHeight = 600;
    config.data = {
      letter: corr.letterText,
    };
    const dialogRef = this.modalService.open(PreviewCorrespondenceComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
      },
      error => this.sharedService.toastr.error("Error"),
      () => { }
    );
  }

  complaintHasIrl(): boolean {

    var found = false;
    if (this.complaint == null) {
      return true;
    }

    if (!this.complaint.actionable) {
      return true;
    }
    if (!this.complaint.firstValid) {
      return true;
    }
    for (var i = 0; i < this.correspondenceList.length; i++) {
      if (this.correspondenceList[i].typeId === 2) {
        found = true;
        break;
      }
    }
    return found;
  }

  complaintHasComplaintCorrespondence(): boolean {

    if (this.complaint == null) {
      return true;
    }
    if (this.complaint.initialComplaint == null) {
      return true;
    }
    if (this.complaint.initialComplaint.contactName == null) {
      return true;
    }
    if (this.complaint.initialComplaint.contactName.length <= 0) {
      return true;
    }
    if (this.correspondenceList == null) {
      return false;
    }
    for (var i = 0; i < this.correspondenceList.length; i++) {
      if (this.correspondenceList[i].typeId === 1) {
        return true;
      }
    }
    return false;
  }

  removeAttachment(correspondence: ICorrespondenceView) {
    this.sharedService.openConfirm("Are you sure you want to delete this document?");

    this.sharedService.confirmed().subscribe(
      confirmed => {
        if (confirmed) {
          this.complaintService.removeAttachment(correspondence.id, correspondence.typeId).subscribe({
            next: response => {
              this.getCorrespondence(this.searchId, this.businessOnly)
              this.sharedService.toastr.success("Correspondence deleted.");
            },
            error: e => {
              this.sharedService.toastr.error("Could not delete Correspondence data.");
            },
          });
        }
      }
    );
  }

  cancel() {
    this.correspondenceHistoryDirty = false;
  }

  attachDocumentSetup(corr: ICorrespondenceView) {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 600;
    config.maxHeight = 800;
    config.data = {
      correspondence: corr,
    };
    const dialogRef = this.modalService.open(AddFileCorrespondenceComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.getCorrespondence(this.searchId, this.businessOnly)
        }
      },
      error => this.sharedService.toastr.error("Error"),
      () => { }
    );
  }

  downloadAttachment(correspondence: ICorrespondenceView) {
    // Very kludgie, but the only way to get the file name
    this.complaintService.getAttachmentFileName(correspondence.id, correspondence.typeId).subscribe(
      (result) => {
        this.fileName = result;
        this.complaintService.downloadCorrespondenceAttachment(correspondence.id, correspondence.typeId).subscribe(
          (result) => {
            this.sharedService.downloadFile(this.fileName, result);
          },
          error => {
            this.sharedService.toastr.error("Could not get File: " + error.message);
          }
        );
      },
      error => {
        this.sharedService.toastr.error("Could not get File: " + error.message);
      }
    );
  }

  loadComplaint(compId: number) {
    this.complaintService.complaintId = compId;
    this.complaintService.complaintTab = 3;
    this.sharedService.doRedirect('complaint/complaint/' + compId);
  }

  showAttachments(correspondence: ICorrespondenceView): boolean {
    let show = !correspondence.hasAttachment && !this.correspondenceHistoryDirty && !correspondence.discardedCorrespondence &&
      correspondence.sentDate != null && correspondence.sentDate.length > 0 && this.complaintId != null && this.complaintId > 0;
    return show;
  }

  getDate(date: string): Date {
    return new Date(date);
  }

  getType(type: number): string{
    if (type != null && type != undefined){
      return this.sharedService.getCorrespondenceType(type.toString());
    }
    return '';
  }
}